import { render, staticRenderFns } from "./DragAndDropContainer.vue?vue&type=template&id=5838d802&scoped=true"
import script from "./DragAndDropContainer.vue?vue&type=script&lang=js"
export * from "./DragAndDropContainer.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropContainer.vue?vue&type=style&index=0&id=5838d802&prod&scoped=true&lang=css"
import style1 from "./DragAndDropContainer.vue?vue&type=style&index=1&id=5838d802&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838d802",
  null
  
)

export default component.exports